import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import Login from '../common/login';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';

const cookies = new Cookies();

// ============================================
// STYLES
// ============================================
const styles = {
    // Main Container
    container: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',
        padding: '30px',
        fontFamily: "'Tajawal', 'Segoe UI', sans-serif",
        direction: 'rtl',
    },

    // Header
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
    },

    backButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        background: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        padding: '12px 20px',
        color: '#64748b',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    },

    pageTitle: {
        fontSize: '28px',
        fontWeight: '700',
        color: '#1e293b',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },

    // Type Badge
    typeBadge: {
        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        color: '#fff',
        padding: '8px 20px',
        borderRadius: '25px',
        fontSize: '14px',
        fontWeight: '600',
    },

    // Main Card
    mainCard: {
        background: '#ffffff',
        borderRadius: '20px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e2e8f0',
        overflow: 'hidden',
    },

    cardHeader: {
        background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
        padding: '20px 28px',
        borderBottom: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },

    cardTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#1e293b',
        margin: 0,
    },

    cardBody: {
        padding: '28px',
    },

    // Form Grid
    formGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '20px',
        marginBottom: '24px',
    },

    // Form Group
    formGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },

    label: {
        fontSize: '13px',
        fontWeight: '600',
        color: '#475569',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },

    input: {
        padding: '12px 16px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '14px',
        color: '#1e293b',
        transition: 'all 0.2s ease',
        outline: 'none',
        background: '#fff',
    },

    inputFocus: {
        borderColor: '#3b82f6',
        boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
    },

    select: {
        padding: '12px 16px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '14px',
        color: '#1e293b',
        background: '#fff',
        cursor: 'pointer',
        outline: 'none',
    },

    textarea: {
        padding: '12px 16px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '14px',
        color: '#1e293b',
        resize: 'vertical',
        minHeight: '80px',
        outline: 'none',
    },

    // Section Divider
    divider: {
        height: '1px',
        background: 'linear-gradient(90deg, transparent, #e2e8f0, transparent)',
        margin: '24px 0',
    },

    // Items Section
    itemsHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
    },

    itemsTitle: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },

    itemsCounter: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        background: '#f8fafc',
        borderRadius: '10px',
        padding: '4px',
        border: '1px solid #e2e8f0',
    },

    counterButton: {
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        border: 'none',
        fontSize: '18px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    counterButtonAdd: {
        background: '#10b981',
        color: '#fff',
    },

    counterButtonRemove: {
        background: '#ef4444',
        color: '#fff',
    },

    counterValue: {
        padding: '0 16px',
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b',
    },

    // Table
    table: {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: '0',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        overflow: 'visible',
    },

    th: {
        background: '#f8fafc',
        padding: '14px 16px',
        fontSize: '12px',
        fontWeight: '600',
        color: '#64748b',
        textAlign: 'center',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        borderBottom: '1px solid #e2e8f0',
    },

    td: {
        padding: '12px',
        borderBottom: '1px solid #f1f5f9',
        verticalAlign: 'middle',
        overflow: 'visible',
        position: 'relative',
    },

    tableInput: {
        width: '100%',
        padding: '10px 12px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        textAlign: 'center',
        outline: 'none',
        transition: 'all 0.2s ease',
    },

    tableInputDisabled: {
        background: '#f8fafc',
        color: '#64748b',
        fontWeight: '600',
    },

    rowNumber: {
        width: '40px',
        height: '40px',
        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        color: '#fff',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '600',
        fontSize: '14px',
        margin: '0 auto',
    },

    // Total Row
    totalRow: {
        background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
    },

    totalLabel: {
        fontSize: '15px',
        fontWeight: '600',
        color: '#16a34a',
    },

    totalValue: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#16a34a',
    },

    // Payment Section
    paymentSection: {
        background: '#f8fafc',
        borderRadius: '12px',
        padding: '20px',
        marginTop: '24px',
    },

    paymentTitle: {
        fontSize: '15px',
        fontWeight: '600',
        color: '#1e293b',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },

    radioGroup: {
        display: 'flex',
        gap: '16px',
        flexWrap: 'wrap',
    },

    radioOption: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 20px',
        background: '#fff',
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: '2px solid #e2e8f0',
    },

    radioOptionSelected: {
        borderColor: '#3b82f6',
        background: '#eff6ff',
    },

    radioCircle: {
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        border: '2px solid #cbd5e1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
    },

    radioCircleSelected: {
        borderColor: '#3b82f6',
        background: '#3b82f6',
    },

    radioLabel: {
        fontSize: '14px',
        color: '#475569',
        fontWeight: '500',
    },

    // Checkbox
    checkboxContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 16px',
        background: '#fff',
        borderRadius: '10px',
        border: '1px solid #e2e8f0',
        cursor: 'pointer',
        marginTop: '16px',
    },

    checkbox: {
        width: '20px',
        height: '20px',
        borderRadius: '6px',
        border: '2px solid #cbd5e1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
    },

    checkboxChecked: {
        background: '#3b82f6',
        borderColor: '#3b82f6',
    },

    // Partial Payment
    partialPayment: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
        marginTop: '16px',
        padding: '16px',
        background: '#fff',
        borderRadius: '10px',
        border: '1px solid #e2e8f0',
    },

    // Submit Button
    submitSection: {
        display: 'flex',
        justifyContent: 'center',
        gap: '16px',
        marginTop: '30px',
        paddingTop: '24px',
        borderTop: '1px solid #e2e8f0',
    },

    submitButton: {
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        border: 'none',
        borderRadius: '12px',
        padding: '16px 48px',
        color: '#fff',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 14px rgba(16, 185, 129, 0.35)',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },

    cancelButton: {
        background: '#fff',
        border: '2px solid #e2e8f0',
        borderRadius: '12px',
        padding: '16px 32px',
        color: '#64748b',
        fontSize: '16px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
    },

    // Spinner
    spinner: {
        width: '24px',
        height: '24px',
        border: '3px solid rgba(255,255,255,0.3)',
        borderTop: '3px solid #fff',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
    },

    // Search Autocomplete Container
    searchContainer: {
        position: 'relative',
        zIndex: 100,
    },

    // Currency
    currency: {
        fontSize: '12px',
        color: '#94a3b8',
        marginRight: '4px',
    },
};

// Global CSS
const globalStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;600;700&display=swap');
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
    }
    
    .input-field:focus {
        border-color: #3b82f6 !important;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
    }
    
    .input-error {
        border-color: #ef4444 !important;
        background-color: #fef2f2 !important;
        animation: shake 0.5s ease-in-out;
    }
    
    .input-error:focus {
        border-color: #ef4444 !important;
        box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
    }
    
    .search-error > div > div:first-child {
        border-color: #ef4444 !important;
        background-color: #fef2f2 !important;
        animation: shake 0.5s ease-in-out;
    }
    
    .error-label {
        color: #ef4444 !important;
    }
    
    @keyframes shake {
        0%, 100% { transform: translateX(0); }
        10%, 30%, 50%, 70%, 90% { transform: translateX(-4px); }
        20%, 40%, 60%, 80% { transform: translateX(4px); }
    }
    
    .submit-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
    }
    
    .cancel-btn:hover {
        background: #f8fafc;
        border-color: #cbd5e1;
    }
    
    .back-btn:hover {
        background: #f8fafc;
        border-color: #cbd5e1;
        color: #3b82f6;
    }
    
    .counter-btn:hover {
        opacity: 0.9;
        transform: scale(1.05);
    }
    
    .table-row:hover {
        background: #f8fafc;
    }
    
    .radio-opt:hover {
        border-color: #cbd5e1;
        background: #f8fafc;
    }
    
    .refresh-btn:hover:not(:disabled) {
        background: #eff6ff !important;
        border-color: #3b82f6 !important;
    }
    
    .refresh-btn:active:not(:disabled) {
        transform: scale(0.98);
    }

    /* Fix ReactSearchAutocomplete z-index */
    .search-container {
        position: relative;
    }
    
    .search-container > div {
        position: relative !important;
    }
    
    .search-container > div > div:nth-child(2) {
        position: absolute !important;
        z-index: 9999 !important;
        width: 100% !important;
        background: #fff !important;
        box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
        border-radius: 8px !important;
    }
    
    /* Ensure table doesn't clip dropdowns */
    table {
        overflow: visible !important;
    }
    
    tbody {
        overflow: visible !important;
    }
    
    tr, td {
        overflow: visible !important;
    }
`;

// ============================================
// ICONS
// ============================================
const Icons = {
    ArrowRight: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
    ),
    FileText: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
    ),
    User: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
        </svg>
    ),
    Calendar: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
    ),
    Truck: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="1" y="3" width="15" height="13"/>
            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
            <circle cx="5.5" cy="18.5" r="2.5"/>
            <circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
    ),
    DollarSign: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="1" x2="12" y2="23"/>
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
    ),
    FileEdit: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 20h9"/>
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
        </svg>
    ),
    Package: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/>
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
            <line x1="12" y1="22.08" x2="12" y2="12"/>
        </svg>
    ),
    CreditCard: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
            <line x1="1" y1="10" x2="23" y2="10"/>
        </svg>
    ),
    Check: () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
        </svg>
    ),
    Plus: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
    ),
    Save: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
            <polyline points="17 21 17 13 7 13 7 21"/>
            <polyline points="7 3 7 8 15 8"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 4 23 10 17 10"/>
            <polyline points="1 20 1 14 7 14"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
};

// Format Result for Autocomplete
const formatResult = (item) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0' }}>
        <span style={{ fontSize: '14px', color: '#1e293b' }}>{item.name}</span>
    </div>
);

// ============================================
// MAIN COMPONENT
// ============================================
class NewBill extends React.Component {
    constructor(props) {
        super(props);
        
        const urlParams = new URLSearchParams(window.location.search);
        const type = urlParams.get('type');
        
        this.state = {
            suppliers: [],
            items: [],
            itemsCount: 1,
            t_price: 0,
            sup_id: "",
            type: "",
            billType: type === "1" ? "منتجات" : "صيانة",
            paymentMethod: 'cash', // cash, partial, transfer
            showPartial: false,
            notFromSafe: false,
            isSubmitting: false,
            isLoadingItems: false, // حالة تحميل المنتجات
        };
    }

    componentDidMount() {
        // Inject global styles
        const styleSheet = document.createElement("style");
        styleSheet.innerText = globalStyles;
        document.head.appendChild(styleSheet);

        const urlParams = new URLSearchParams(window.location.search);
        const type = urlParams.get('type');
        
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        
        // Fetch suppliers
        axios.get(host + `dashbord/Suppliers/all`, { headers: header })
            .then(res => this.setState({ suppliers: res.data.suppliers || [] }))
            .catch(error => console.log(error.response));

        // Fetch items
        axios.get(host + `dashbord/items/get/all?type=${type}`, { headers: header })
            .then(res => this.setState({ items: res.data.items || [] }))
            .catch(error => console.log(error.response));
    }

    // تحديث المنتجات
    refreshItems = () => {
        this.setState({ isLoadingItems: true });
        
        const urlParams = new URLSearchParams(window.location.search);
        const type = urlParams.get('type');
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };

        axios.get(host + `dashbord/items/get/all?type=${type}`, { headers: header })
            .then(res => {
                this.setState({ 
                    items: res.data.items || [],
                    isLoadingItems: false 
                });
                toast.success('تم تحديث المنتجات بنجاح', { 
                    icon: '✅',
                    autoClose: 2000 
                });
            })
            .catch(error => {
                console.log(error.response);
                this.setState({ isLoadingItems: false });
                toast.error('حدث خطأ في تحديث المنتجات', { icon: '❌' });
            });
    }

    calculateTotal = () => {
        let price = 0;
        for (let i = 0; i < this.state.itemsCount; i++) {
            const priceEl = document.getElementById(`price${i + 1}`);
            const countEl = document.getElementById(`count${i + 1}`);
            const totalEl = document.getElementById(`priceAll${i + 1}`);
            
            if (priceEl && countEl && totalEl) {
                const p = (parseFloat(priceEl.value) || 0) * (parseFloat(countEl.value) || 0);
                totalEl.value = p.toFixed(2);
                price += p;
            }
        }
        this.setState({ t_price: price.toFixed(2) });
        
        // Update remaining if partial payment
        const paidEl = document.getElementById('paidPrit');
        const remEl = document.getElementById('rem');
        if (paidEl && remEl && this.state.showPartial) {
            remEl.value = (price - (parseFloat(paidEl.value) || 0)).toFixed(2);
        }
    }

    // إزالة class الخطأ من جميع الحقول
    clearErrors = () => {
        document.querySelectorAll('.input-error, .search-error, .error-label').forEach(el => {
            el.classList.remove('input-error', 'search-error', 'error-label');
        });
    }

    // تحديد حقل كخطأ
    setFieldError = (fieldId, labelText = null) => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.classList.add('input-error');
            field.scrollIntoView({ behavior: 'smooth', block: 'center' });
            field.focus();
        }
        
        // تحديد الـ label إذا وجد
        if (labelText) {
            const labels = document.querySelectorAll('label');
            labels.forEach(label => {
                if (label.textContent.includes(labelText)) {
                    label.classList.add('error-label');
                }
            });
        }
    }

    // تحديد حقل البحث كخطأ
    setSearchError = (index) => {
        const searchContainer = document.querySelector(`#item${index}`)?.parentElement;
        if (searchContainer) {
            searchContainer.classList.add('search-error');
            searchContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    validateForm = () => {
        // إزالة الأخطاء السابقة
        this.clearErrors();
        
        const { sup_id, type, itemsCount } = this.state;
        const listDateEl = document.getElementById("listDate");
        const shippingEl = document.getElementById("shipping");
        const listDate = listDateEl?.value;
        const shipping = shippingEl?.value;

        // التحقق من التاجر
        if (!sup_id) {
            toast.error('يرجى اختيار التاجر', { icon: '⚠️' });
            const supplierSearch = document.querySelector('.search-container');
            if (supplierSearch) {
                supplierSearch.classList.add('search-error');
                supplierSearch.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return false;
        }

        // التحقق من نوع النقل
        if (!type || type === "none") {
            toast.error('يرجى اختيار نوع النقل', { icon: '⚠️' });
            const selectEl = document.querySelector('select');
            if (selectEl) {
                selectEl.classList.add('input-error');
                selectEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                selectEl.focus();
            }
            return false;
        }

        // التحقق من تاريخ القائمة
        if (!listDate) {
            toast.error('يرجى إدخال تاريخ القائمة', { icon: '📅' });
            this.setFieldError('listDate', 'تاريخ');
            return false;
        }

        // التحقق من مصاريف النقل
        if (!shipping && shipping !== '0') {
            toast.error('يرجى إدخال مصاريف النقل (أدخل 0 إذا لا يوجد)', { icon: '💰' });
            this.setFieldError('shipping', 'مصاريف');
            return false;
        }

        // التحقق من المنتجات
        for (let i = 0; i < itemsCount; i++) {
            const num = i + 1;
            const itemId = document.getElementById(`item${num}`)?.value;
            const count = document.getElementById(`count${num}`)?.value;
            const price = document.getElementById(`price${num}`)?.value;

            // التحقق من اختيار المنتج
            if (!itemId) {
                toast.error(`يرجى اختيار المنتج في الصف ${num}`, { icon: '📦' });
                this.setSearchError(num);
                return false;
            }

            // التحقق من العدد
            if (!count || parseFloat(count) < 1) {
                toast.error(`يرجى إدخال العدد في الصف ${num}`, { icon: '🔢' });
                this.setFieldError(`count${num}`);
                return false;
            }

            // التحقق من السعر
            if (!price || parseFloat(price) <= 0) {
                toast.error(`يرجى إدخال السعر في الصف ${num}`, { icon: '💵' });
                this.setFieldError(`price${num}`);
                return false;
            }
        }

        return true;
    }

    handleSubmit = () => {
        if (!this.validateForm()) return;

        this.setState({ isSubmitting: true });

        const { sup_id, type, itemsCount, t_price, paymentMethod, notFromSafe } = this.state;
        const listDate = document.getElementById("listDate").value;
        const notes = document.getElementById("notes").value;
        const shipping = document.getElementById("shipping").value;

        // Collect items
        const items = [];
        for (let i = 0; i < itemsCount; i++) {
            items.push({
                count: document.getElementById(`count${i + 1}`).value,
                price: document.getElementById(`price${i + 1}`).value,
                items_id: document.getElementById(`item${i + 1}`).value,
            });
        }

        const isPartial = paymentMethod === 'partial';
        const isTransfer = paymentMethod === 'transfer';
        const paidAmount = document.getElementById('paidPrit')?.value || 0;

        const urlParams = new URLSearchParams(window.location.search);
        const Listtype = urlParams.get('type');

        axios.post(host + `dashbord/bill/new`, {
            sup_id,
            listDate,
            notes,
            shipping,
            items,
            check: isPartial,
            price: t_price,
            p_price: paidAmount,
            type,
            Listtype,
            safeCheck: notFromSafe,
            transfer: isTransfer,
        })
        .then(() => {
            toast.success('تم إنشاء الفاتورة بنجاح');
            setTimeout(() => window.location.href = "/billsList", 1000);
        })
        .catch(error => {
            console.log(error);
            toast.error('حدث خطأ في إنشاء الفاتورة');
            this.setState({ isSubmitting: false });
        });
    }

    renderItemRow = (index) => {
        const num = index + 1;
        const zIndex = 1000 - index; // الصفوف العلوية لها z-index أعلى
        
        return (
            <tr 
                key={index} 
                className="table-row" 
                style={{ 
                    animation: `fadeIn 0.3s ease ${index * 0.05}s both`,
                    position: 'relative',
                    zIndex: zIndex,
                }}
            >
                <td style={styles.td}>
                    <div style={styles.rowNumber}>{num}</div>
                </td>
                <td style={{ ...styles.td, width: '35%', position: 'relative', zIndex: zIndex }}>
                    <input type="hidden" id={`item${num}`} />
                    <div style={{ position: 'relative', zIndex: zIndex }}>
                        <ReactSearchAutocomplete
                            items={this.state.items}
                            onSelect={(item) => {
                                document.getElementById(`item${num}`).value = item.id;
                                document.getElementById(`price${num}`).value = item.dw_price;
                                // إزالة class الخطأ
                                const container = document.getElementById(`item${num}`)?.parentElement;
                                if (container) container.classList.remove('search-error');
                                this.calculateTotal();
                            }}
                            onClear={() => {
                                document.getElementById(`item${num}`).value = '';
                            }}
                            placeholder="ابحث عن المنتج..."
                            styling={{
                                height: "44px",
                                border: "2px solid #e2e8f0",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                                boxShadow: "none",
                                fontSize: "14px",
                                fontFamily: "'Tajawal', sans-serif",
                                zIndex: zIndex,
                            }}
                            formatResult={formatResult}
                        />
                    </div>
                </td>
                <td style={styles.td}>
                    <input
                        type="number"
                        id={`count${num}`}
                        style={styles.tableInput}
                        className="input-field"
                        placeholder="0"
                        min="1"
                        onChange={(e) => {
                            e.target.classList.remove('input-error');
                            this.calculateTotal();
                        }}
                    />
                </td>
                <td style={styles.td}>
                    <input
                        type="number"
                        id={`price${num}`}
                        style={styles.tableInput}
                        className="input-field"
                        placeholder="0.00"
                        step="0.01"
                        onChange={(e) => {
                            e.target.classList.remove('input-error');
                            this.calculateTotal();
                        }}
                    />
                </td>
                <td style={styles.td}>
                    <input
                        type="text"
                        id={`priceAll${num}`}
                        style={{ ...styles.tableInput, ...styles.tableInputDisabled }}
                        disabled
                        placeholder="0.00"
                    />
                </td>
            </tr>
        );
    }

    render() {
        if (!cookies.get("token")) return <Login />;

        const { suppliers, itemsCount, t_price, billType, paymentMethod, showPartial, notFromSafe, isSubmitting, isLoadingItems } = this.state;

        return (
            <div style={styles.container}>
                <ToastContainer position="top-center" rtl theme="light" />

                {/* Header */}
                <div style={styles.header}>
                    <Link to="/billsList" style={styles.backButton} className="back-btn">
                        <Icons.ArrowRight />
                        <span>العودة للقوائم</span>
                    </Link>
                    
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <h1 style={styles.pageTitle}>
                            <Icons.FileText />
                            إنشاء فاتورة جديدة
                        </h1>
                        <span style={styles.typeBadge}>{billType}</span>
                    </div>
                </div>

                {/* Main Card */}
                <div style={styles.mainCard}>
                    {/* Card Header */}
                    <div style={styles.cardHeader}>
                        <Icons.FileEdit />
                        <h2 style={styles.cardTitle}>معلومات الفاتورة</h2>
                    </div>

                    {/* Card Body */}
                    <div style={styles.cardBody}>
                        {/* Basic Info Grid */}
                        <div style={styles.formGrid}>
                            {/* Supplier */}
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icons.User />
                                    اسم التاجر
                                </label>
                                <div className="search-container" style={{ ...styles.searchContainer, zIndex: 200 }}>
                                    <ReactSearchAutocomplete
                                        items={suppliers}
                                        onSelect={(item) => this.setState({ sup_id: item.id })}
                                        placeholder="ابحث عن التاجر..."
                                        styling={{
                                            height: "46px",
                                            border: "2px solid #e2e8f0",
                                            borderRadius: "10px",
                                            backgroundColor: "#fff",
                                            boxShadow: "none",
                                            fontSize: "14px",
                                            fontFamily: "'Tajawal', sans-serif",
                                            zIndex: 200,
                                        }}
                                        formatResult={formatResult}
                                    />
                                </div>
                            </div>

                            {/* Date */}
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icons.Calendar />
                                    تاريخ القائمة
                                </label>
                                <input
                                    type="date"
                                    id="listDate"
                                    style={styles.input}
                                    className="input-field"
                                    onChange={(e) => e.target.classList.remove('input-error')}
                                />
                            </div>

                            {/* Transport Type */}
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icons.Truck />
                                    نوع النقل
                                </label>
                                <select
                                    style={styles.select}
                                    className="input-field"
                                    onChange={(e) => {
                                        e.target.classList.remove('input-error');
                                        this.setState({ type: e.target.value });
                                    }}
                                    defaultValue="none"
                                >
                                    <option value="none">اختر النوع</option>
                                    <option value="in">داخلي</option>
                                    <option value="out">خارجي</option>
                                </select>
                            </div>

                            {/* Shipping Cost */}
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icons.DollarSign />
                                    مصاريف أخرى
                                </label>
                                <input
                                    type="number"
                                    id="shipping"
                                    style={styles.input}
                                    className="input-field"
                                    placeholder="النقل أو التحويلات"
                                    onChange={(e) => e.target.classList.remove('input-error')}
                                />
                            </div>

                            {/* Notes */}
                            <div style={{ ...styles.formGroup, gridColumn: 'span 2' }}>
                                <label style={styles.label}>
                                    <Icons.FileEdit />
                                    ملاحظات
                                </label>
                                <textarea
                                    id="notes"
                                    style={styles.textarea}
                                    className="input-field"
                                    placeholder="أضف ملاحظات إضافية..."
                                />
                            </div>
                        </div>

                        <div style={styles.divider} />

                        {/* Items Section */}
                        <div style={styles.itemsHeader}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={styles.itemsTitle}>
                                    <Icons.Package />
                                    المنتجات
                                </div>
                                
                                {/* زر تحديث المنتجات */}
                                <button
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        background: isLoadingItems ? '#f1f5f9' : '#fff',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '8px',
                                        padding: '8px 14px',
                                        fontSize: '13px',
                                        color: isLoadingItems ? '#94a3b8' : '#3b82f6',
                                        cursor: isLoadingItems ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease',
                                        fontWeight: '500',
                                        fontFamily: "'Tajawal', sans-serif",
                                    }}
                                    className="refresh-btn"
                                    onClick={this.refreshItems}
                                    disabled={isLoadingItems}
                                >
                                    {isLoadingItems ? (
                                        <>
                                            <div style={{
                                                width: '14px',
                                                height: '14px',
                                                border: '2px solid #e2e8f0',
                                                borderTop: '2px solid #3b82f6',
                                                borderRadius: '50%',
                                                animation: 'spin 0.8s linear infinite',
                                            }} />
                                            جاري التحديث...
                                        </>
                                    ) : (
                                        <>
                                            <Icons.Refresh />
                                            تحديث المنتجات
                                        </>
                                    )}
                                </button>
                                
                                {/* عدد المنتجات */}
                                <span style={{
                                    background: '#eff6ff',
                                    color: '#3b82f6',
                                    padding: '4px 10px',
                                    borderRadius: '12px',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                }}>
                                    {this.state.items.length} منتج
                                </span>
                            </div>
                            
                            <div style={styles.itemsCounter}>
                                <button
                                    style={{ ...styles.counterButton, ...styles.counterButtonAdd }}
                                    className="counter-btn"
                                    onClick={() => {
                                        this.setState({ itemsCount: itemsCount + 1 });
                                        setTimeout(this.calculateTotal, 100);
                                    }}
                                >
                                    +
                                </button>
                                <span style={styles.counterValue}>{itemsCount}</span>
                                <button
                                    style={{ ...styles.counterButton, ...styles.counterButtonRemove }}
                                    className="counter-btn"
                                    onClick={() => {
                                        if (itemsCount > 1) {
                                            this.setState({ itemsCount: itemsCount - 1 });
                                            setTimeout(this.calculateTotal, 100);
                                        }
                                    }}
                                >
                                    -
                                </button>
                            </div>
                        </div>

                        {/* Items Table */}
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.th}>#</th>
                                    <th style={styles.th}>المنتج</th>
                                    <th style={styles.th}>العدد</th>
                                    <th style={styles.th}>سعر القطعة</th>
                                    <th style={styles.th}>الإجمالي</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.from({ length: itemsCount }, (_, i) => this.renderItemRow(i))}
                                
                                {/* Total Row */}
                                <tr style={styles.totalRow}>
                                    <td colSpan="3" style={{ ...styles.td, textAlign: 'left' }}>
                                        <span style={styles.totalLabel}>المجموع الكلي</span>
                                    </td>
                                    <td colSpan="2" style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={styles.totalValue}>
                                            {parseFloat(t_price).toLocaleString()}
                                            <span style={styles.currency}>د.ع</span>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div style={styles.divider} />

                        {/* Payment Section */}
                        <div style={styles.paymentSection}>
                            <div style={styles.paymentTitle}>
                                <Icons.CreditCard />
                                طريقة الدفع
                            </div>

                            <div style={styles.radioGroup}>
                                {/* Cash */}
                                <div
                                    style={{
                                        ...styles.radioOption,
                                        ...(paymentMethod === 'cash' ? styles.radioOptionSelected : {})
                                    }}
                                    className="radio-opt"
                                    onClick={() => this.setState({ paymentMethod: 'cash', showPartial: false })}
                                >
                                    <div style={{
                                        ...styles.radioCircle,
                                        ...(paymentMethod === 'cash' ? styles.radioCircleSelected : {})
                                    }}>
                                        {paymentMethod === 'cash' && <Icons.Check />}
                                    </div>
                                    <span style={styles.radioLabel}>نقدي كامل</span>
                                </div>

                                {/* Partial */}
                                <div
                                    style={{
                                        ...styles.radioOption,
                                        ...(paymentMethod === 'partial' ? styles.radioOptionSelected : {})
                                    }}
                                    className="radio-opt"
                                    onClick={() => this.setState({ paymentMethod: 'partial', showPartial: true })}
                                >
                                    <div style={{
                                        ...styles.radioCircle,
                                        ...(paymentMethod === 'partial' ? styles.radioCircleSelected : {})
                                    }}>
                                        {paymentMethod === 'partial' && <Icons.Check />}
                                    </div>
                                    <span style={styles.radioLabel}>دفع بالآجل</span>
                                </div>

                                {/* Transfer */}
                                <div
                                    style={{
                                        ...styles.radioOption,
                                        ...(paymentMethod === 'transfer' ? styles.radioOptionSelected : {})
                                    }}
                                    className="radio-opt"
                                    onClick={() => this.setState({ paymentMethod: 'transfer', showPartial: true })}
                                >
                                    <div style={{
                                        ...styles.radioCircle,
                                        ...(paymentMethod === 'transfer' ? styles.radioCircleSelected : {})
                                    }}>
                                        {paymentMethod === 'transfer' && <Icons.Check />}
                                    </div>
                                    <span style={styles.radioLabel}>تحويل</span>
                                </div>
                            </div>

                            {/* Partial Payment Fields */}
                            {showPartial && (
                                <div style={styles.partialPayment}>
                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>الدفعة الجزئية</label>
                                        <input
                                            type="number"
                                            id="paidPrit"
                                            style={styles.input}
                                            className="input-field"
                                            placeholder="0.00"
                                            onChange={(e) => {
                                                const rem = t_price - (parseFloat(e.target.value) || 0);
                                                document.getElementById('rem').value = rem.toFixed(2);
                                            }}
                                        />
                                    </div>
                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>المتبقي</label>
                                        <input
                                            type="number"
                                            id="rem"
                                            style={{ ...styles.input, ...styles.tableInputDisabled }}
                                            disabled
                                            placeholder="0.00"
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Not from Safe Checkbox */}
                            <div
                                style={styles.checkboxContainer}
                                onClick={() => this.setState({ notFromSafe: !notFromSafe })}
                            >
                                <div style={{
                                    ...styles.checkbox,
                                    ...(notFromSafe ? styles.checkboxChecked : {})
                                }}>
                                    {notFromSafe && <Icons.Check />}
                                </div>
                                <span style={styles.radioLabel}>ليس من القاصة</span>
                            </div>
                        </div>

                        {/* Submit Section */}
                        <div style={styles.submitSection}>
                            <Link to="/billsList" style={{ textDecoration: 'none' }}>
                                <button style={styles.cancelButton} className="cancel-btn">
                                    إلغاء
                                </button>
                            </Link>
                            <button
                                style={styles.submitButton}
                                className="submit-btn"
                                onClick={this.handleSubmit}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <div style={styles.spinner} />
                                        جاري الحفظ...
                                    </>
                                ) : (
                                    <>
                                        <Icons.Save />
                                        حفظ الفاتورة
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewBill;
